import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createQuiz, getQuizzes, deleteQuiz as deleteQuizApi, getQuizById, updateQuiz, getUserQuizSubmissions } from '../api/quiz';

export const useCreateQuiz = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['create-quiz'],
        mutationFn: (data) => createQuiz(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['quizzes'] });
        },
    });
}

export const useGetQuizById = (id) => {
    return useQuery({
        queryKey: ['quiz', id],
        queryFn: () => getQuizById(id),
        enabled: !!id, // Only run the query if id is truthy
    });
}

export const useUpdateQuiz = (id) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['update-quiz', id],
        mutationFn: (data) => updateQuiz(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['quizzes'] });
        },
    });
}

export const useGetQuizzes = () => {
    return useQuery({
        queryKey: ['quizzes'],
        queryFn: () => getQuizzes(),
    });
}

export const useDeleteQuiz = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationKey: ['delete-quiz'],
        mutationFn: (id) => deleteQuizApi(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['quizzes'] });
        },
    });
}

export const useGetUserQuizSubmissions = (quizId) => {
    return useQuery({
        queryKey: ['quiz-submissions', quizId],
        queryFn: () => getUserQuizSubmissions(quizId), // Assuming this function fetches submissions
        enabled: !!quizId, // Only run the query if quizId is truthy
        retry: 1,
    });
}